import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logErrors } from "../actions/error_actions";

class ErrorBoundary extends Component {
  static propTypes = {
    userInfo: PropTypes.object,
    trouble: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    this.props.logErrors({
      error: error.toString(),
      info: info.componentStack,
      user_id: this.props.userInfo.id,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-container">
          <div className="error-content">
            <div className="info-container">
              <div className="error-column">
                <h1 className="error-header">Oops!</h1>
                <h1 className="error-tagline">Something's not right here...</h1>
                <p className="info-text">
                  An error report has been dispatched to our development team
                  and they're currently investigating.
                  <br />
                  <br />
                  Please contact us at{" "}
                  <a
                    className="info-link"
                    href="mailto:service@figloans.com"
                    style={{
                      color: "#e47a36",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    service@figloans.com
                  </a>{" "}
                  if you have any additional questions.
                </p>
                <p className="info-text">
                  Click the button below to return to the home page:
                </p>
                <a className="error-button" href="/">
                  Click Here
                </a>
              </div>
              <div className="error-column">
                <img
                  className="error-image"
                  src="https://i.imgur.com/2jeWF8v.png"
                  alt="Scientist Standing in Front of Unplugged Extension Cord"
                />
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.session.currentUser || {},
  trouble: Object.values(state.errors.session),
});

const mapDispatchToProps = (dispatch) => ({
  logErrors: (error) => dispatch(logErrors(error)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
